import { render } from "./EndShiftSugar.vue?vue&type=template&id=5a18c9a3&scoped=true&lang=true"
import script from "./EndShiftSugar.vue?vue&type=script&lang=js"
export * from "./EndShiftSugar.vue?vue&type=script&lang=js"

import "./EndShiftSugar.vue?vue&type=style&index=0&id=5a18c9a3&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a18c9a3"]])

export default __exports__